export const prevArrow = `
    <button class="slider__arrow slider__prev">
        <svg xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 53 53">
            <g id="Group_94" data-name="Group 94" transform="translate(1781 2427) rotate(180)">
                <rect id="Rectangle_310" data-name="Rectangle 310" width="53" height="53" transform="translate(1728 2374)" fill="#f0e8e1"/>
                <path id="Path_72" data-name="Path 72" d="M0,10.783,10.783,0,21.566,10.783" transform="translate(1759.678 2389.931) rotate(90)" fill="none" stroke="#fff" stroke-width="4"/>
            </g>
        </svg>
    </button>`;
export const nextArrow = `
    <button class="slider__arrow slider__next">
        <svg xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 53 53">
            <g id="Group_94" data-name="Group 94" transform="translate(-1728 -2374)">
                <rect id="Rectangle_310" data-name="Rectangle 310" width="53" height="53" transform="translate(1728 2374)" fill="#f0e8e1"/>
                <path id="Path_72" data-name="Path 72" d="M0,10.783,10.783,0,21.566,10.783" transform="translate(1759.678 2389.931) rotate(90)" fill="none" stroke="#fff" stroke-width="4"/>
            </g>
        </svg>
    </button>`;

export const options = {
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    cssEase: 'ease',
    speed: 300,
    nextArrow,
    prevArrow
};

